import { Avatar, Box, Container, Divider, useMediaQuery } from "@mui/material"
import { Facebook, LinkedIn, Instagram, XSocial, MessageIconBottom, LocationIcon, PhoneIconBottom, FacebookMobile, LinkedInMobile, InstagramMobile, XSocialMobile } from '../../../../core/global/Icons';
import biz_logo from '../../../../assets/images/logos/biz_logo.png'

export const Bottom = () => {
    const md = useMediaQuery('(max-width:900px)');

    const redirect = (name) => {
        if (name === 'fb') {
            window.location.href = 'https://www.facebook.com/pofbusinessmain/';
        }else if(name === 'ig') {
            window.location.href = 'https://instagram.com/pofbusinessofficial';
        }else if(name === 'twr') {
            window.location.href = 'https://twitter.com/PofBusiness';
        }else if(name === 'lnk') {
            window.location.href = 'https://www.linkedin.com/company/pofbusiness/';
        }else if(name === 'terms') {
            window.location.href = 'https://pofsis.pofsis.com/termsandconditions/';
        }else if(name === 'privacy') {
            window.location.href = 'https://pofsis.pofsis.com/privacy-policy/';
        }else if(name === 'cookies') {
            window.location.href = 'https://pofsis.pofsis.com/cookiepolicy';
        }else if(name === 'blogs') {
            // window.location.href = 'https://blogs-personal.pofsis.com/category/productivity/';
            // window.location.href = '#';
            return
        }
    }

    return (
        <Box minHeight={{xs:"618px", md:"574px"}} width="100%" display="flex" flexDirection="column">
            <Box minHeight={{xs:"572px", md:"474px"}} width="100%" bgcolor="#003022">
                <Container maxWidth="xl" sx={{ p:{xs:'40px 24px 24px 24px', md:'auto'}, height:'100%', display:'flex', flexDirection:{xs:'column', md:'row'}, justifyContent:'center', alignItems:'center', gap:{xs:'24px', md:'49px'}}}>
                    <Box>
                        <Avatar src={biz_logo} variant="square" sx={{height:{xs:40, md:72}, width:{xs:40, md:72} }} />
                    </Box>
                    <Box width={{xs:'100%', md:"200px"}} display="flex" flexDirection="column" gap={{xs:"12px", md:"16px"}}>
                        <Box fontSize={12} fontWeight={600} lineHeight="14.4px" color={{xs:'#ACC6B1', md:"#7C9F83"}}>Other Links</Box>
                        <Box fontSize={14} fontWeight={400} lineHeight="20.58px" color="#DAE8DA" className="c-pointer" onClick={()=>redirect('terms')}>Terms of Use</Box>
                        <Box fontSize={14} fontWeight={400} lineHeight="20.58px" color="#DAE8DA" className="c-pointer" onClick={()=>redirect('privacy')}>Privacy Policy</Box>
                        <Box fontSize={14} fontWeight={400} lineHeight="20.58px" color="#DAE8DA" className="c-pointer" onClick={()=>redirect('cookies')}>Cookies Policy</Box>
                        {/* <Box fontSize={14} fontWeight={400} lineHeight="20.58px" color="#DAE8DA" className="c-pointer" onClick={()=>redirect('blogs')}>Blogs</Box> */}
                    </Box>
                    <Divider sx={{display:{xs:'block', md:'none'}, bgcolor:'#002016', height:'2px', width:'100%'}}/>
                    <Box display="flex" flexDirection="column" gap="12px">
                        <Box fontSize={{xs:12, md:16}} fontWeight={{xs:400, md:600}} lineHeight={{xs:'17.04px', md:"19.2px"}} letterSpacing="-0.75%" color="#DAE8DA" display="flex" flexDirection="column" gap="8px">
                            <MessageIconBottom/>
                            <Box>pofbusiness@pofsis.com</Box>
                        </Box>
                        <Box fontSize={{xs:12, md:14}} fontWeight={400} lineHeight={{xs:'17.04px', md:"20.58px"}} color="#DAE8DA" display="flex" flexDirection="column" gap="8px">
                            <LocationIcon/>
                            <Box>2005B 20th Floor West Tower, Tektite Tower, Ortigas Center, Pasig City, Metro Manila 1605 Philippines</Box>
                        </Box>
                        <Box fontSize={{xs:12, md:14}} fontWeight={400} lineHeight={{xs:'17.04px', md:"20.58px"}} color="#DAE8DA" display="flex" flexDirection="column" gap="8px">
                            <PhoneIconBottom/>
                            <Box>(+632) 8687 6649</Box>
                        </Box>
                    </Box>
                    <Box display="flex" justifyContent="center" alignItems="center" gap="24px" className="c-pointer">
                        <Box onClick={()=>redirect('fb')}>{md? <FacebookMobile/> : <Facebook/>}</Box>
                        <Box onClick={()=>redirect('lnk')}>{md? <LinkedInMobile/> : <LinkedIn/>}</Box>
                        <Box onClick={()=>redirect('ig')}>{md? <InstagramMobile/> : <Instagram/>}</Box>
                        <Box onClick={()=>redirect('twr')}>{md? <XSocialMobile/> : <XSocial/>}</Box>
                    </Box>
                </Container>
            </Box>
            <Box height={{xs:"46px", md:"100px"}} width="100%" bgcolor="#003F2E" display="flex" justifyContent="center" alignItems="center">
                <Box fontSize={{mobile:10, desktop:14}} fontWeight={400} lineHeight={{mobile:'14.2px', desktop:"19.88px"}} color="#DAE8DA">©2024 Business. All rights reserved.</Box>
            </Box>
        </Box>
    )
}